var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2627 36.0015C16.2627 38.2107 18.0536 40.0015 20.2627 40.0015C22.4718 40.0015 24.2627 38.2107 24.2627 36.0015V23.9998H36.2642C38.4734 23.9998 40.2642 22.2089 40.2642 19.9998C40.2642 17.7906 38.4734 15.9998 36.2642 15.9998H24.2627V3.99854C24.2627 1.78939 22.4718 -0.00146484 20.2627 -0.00146484C18.0536 -0.00146484 16.2627 1.78939 16.2627 3.99854V15.9998H4.26123C2.05209 15.9998 0.26123 17.7906 0.26123 19.9998C0.26123 22.2089 2.05209 23.9998 4.26123 23.9998H16.2627V36.0015Z",
    fill: "#38A6D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.55800083052fef9560a0d4a72ba8aebd.svg";
export { ForwardRef as ReactComponent };